import React from 'react'

export default (props) => {
  return (
    <svg width="16px" height="16px" viewBox="0 0 16 16" {...props}>
      <g id="全家桶视觉方案优化" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="工作台1" transform="translate(-730.000000, -299.000000)">
          <g id="分组-6" transform="translate(240.000000, 96.000000)">
            <g id="编组-18" transform="translate(0.000000, 171.000000)">
              <g id="复制" transform="translate(490.000000, 32.000000)">
                <rect
                  id="矩形"
                  fill="#D8D8D8"
                  opacity="0"
                  x="0"
                  y="0"
                  width="16"
                  height="16"
                ></rect>
                <g
                  id="编组-5"
                  transform="translate(2.223389, 1.330322)"
                  stroke="#1e90ff"
                  strokeLinecap="round"
                  strokeWidth="1.2"
                >
                  <polygon
                    id="路径"
                    strokeLinejoin="round"
                    points="2 11.3333333 11.3333333 11.3333333 11.3333333 4 7.66666667 -8.8817842e-15 2 -8.8817842e-15"
                  ></polygon>
                  <polyline
                    id="路径"
                    strokeLinejoin="round"
                    points="7.66666667 0 7.66666667 4 11.3333333 4"
                  ></polyline>
                  <polyline
                    id="路径"
                    strokeLinejoin="round"
                    points="0 5.33333333 0 13.3333333 7 13.3333333"
                  ></polyline>
                  <line x1="4" y1="5.33333333" x2="5.33333333" y2="5.33333333" id="路径"></line>
                  <line x1="4" y1="8" x2="8" y2="8" id="路径"></line>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
